import React from 'react'
import { StyledHeading } from 'component-library/typography/Heading/Heading.styled'

export interface Props {
    text: string
    className?: string
}

export const Heading: React.FC<Props> = ({ text, className }) => (
    <StyledHeading className={className}>{text}</StyledHeading>
)
Heading.displayName = 'Heading'
